import { render, staticRenderFns } from "./iconButton.vue?vue&type=template&id=70911994"
import script from "./iconButton.vue?vue&type=script&lang=js"
export * from "./iconButton.vue?vue&type=script&lang=js"
import style0 from "./iconButton.vue?vue&type=style&index=0&id=70911994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports